import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.detail || error.message || 'An error occurred';
    console.error('API Error:', message);
    return Promise.reject(error);
  }
);

export const getDashboardSummary = (params = {}) =>
  api.get('/dashboard/summary', { params }).then((r) => r.data);

export const getDashboardTrend = (days = 30, params = {}) =>
  api.get('/dashboard/trend', { params: { days, ...params } }).then((r) => r.data);

export const getDashboardAccuracy = (params = {}) =>
  api.get('/dashboard/accuracy', { params }).then((r) => r.data);

export const getCases = (params = {}) =>
  api.get('/cases', { params }).then((r) => r.data);

export const getCaseDetail = (studyFk) =>
  api.get(`/cases/${encodeURIComponent(studyFk)}`).then((r) => r.data);

export const getReferringPhysicians = (limit = 20) =>
  api.get('/dashboard/referring-physicians', { params: { limit } }).then((r) => r.data);

export const getPathologyAccuracy = (includeOutOfScope = false, params = {}) =>
  api
    .get('/pathology/accuracy', { params: { include_out_of_scope: includeOutOfScope, ...params } })
    .then((r) => r.data);

export const getPathologyStudies = (name, params = {}) =>
  api.get(`/pathology/${encodeURIComponent(name)}/studies`, { params }).then((r) => r.data);

export default api;
